import React from 'react';
import styled, { css } from 'styled-components';
import { get, Icon } from '@ally/metronome-ui';
import { muiCancelFill, muiErrorFill, muiSuccessFill, } from '@ally/metronome-icons';
const sharedStyles = css `
  ${({ status, hasProgress, markerType, theme: { colors, media, space }, }) => `
    display: block;
    position: relative;
    margin-bottom: ${space.xxs};

    &:before {
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      z-index: 1;
      width: ${space.lg};
      height: ${space.lg};
      margin-left: auto;
      margin-right: auto;
      border-width: 1px;
      border-style: solid;
      border-radius: 50%;
      outline: ${space.xs} solid ${colors.white};
    }

    &:after {
      content: '';
      display: block;
      position: absolute;
      background-color: ${status === 'Success' ? colors.plum : colors['slate-2']};
      ${(markerType === 'start' && hasProgress) ||
    (markerType === 'default' && status === 'Success')
    ? `background-color: ${colors.plum};`
    : `background-color: ${colors['slate-2']};`}
      top: 50%;
      right: -50%;
      width: 100%;
      height: 1px;
    }

    ${media.down('md')} {
      margin-right: ${space.sm};
      margin-bottom: 0;

      &:before {
        margin: 0;
      }

      &:after {
        display: none;
      }
    }
  `}
`;
const TrackerMarker = styled.div `
  ${sharedStyles}

  ${({ status, theme: { colors } }) => `
    color: ${status === 'Current' ? colors.plum : colors['slate-400']};

    &:before {
      content: counter(counter);
      background-color: ${colors.white};
      border-color: ${status === 'Current' ? colors.plum : colors['slate-400']};
    }
  `}

  font-size: ${get.fontSizes('sm')};
`;
const IconWrapper = styled.div `
  ${sharedStyles}

  &:before {
    display: none;
  }
`;
const StyledIcon = styled(Icon) `
  position: relative;
  z-index: 1;
  background-color: ${get.colors('white')};
  outline: ${get.space('xs')} solid ${get.colors('white')};
`;
const TimelineTrackerMarker = ({ hasProgress, isFirstStep, markerType, status, }) => {
    const trackerIcons = {
        Warning: {
            icon: muiErrorFill,
            fill: 'warning',
        },
        Success: {
            icon: muiSuccessFill,
            fill: 'plum',
        },
        Canceled: {
            icon: muiCancelFill,
            fill: 'slate-3',
        },
    };
    const shouldDisplayIcon = Object.keys(trackerIcons).includes(status);
    return shouldDisplayIcon ? (React.createElement(IconWrapper, { hasProgress: hasProgress, isFirstStep: isFirstStep, markerType: markerType, status: status },
        React.createElement(StyledIcon, { icon: trackerIcons[status].icon, fill: trackerIcons[status]
                .fill, size: "xl", "aria-hidden": true }))) : (React.createElement(TrackerMarker, { hasProgress: hasProgress, isFirstStep: isFirstStep, markerType: markerType, status: status }));
};
export default TimelineTrackerMarker;
//# sourceMappingURL=TimelineTrackerMarker.js.map